import { Component, Input, OnInit } from '@angular/core';
import { Employee, EmployeeService, Calendar, PresenceUpdate, PresenceUpdateDay } from 'toolbandi-ui-lib';
import { MessageService } from 'elbuild-ui-lib-core';
import { DialogService } from 'elbuild-ui-componentslib';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-employee-precenceupdate',
	templateUrl: './employee-precenceupdate.component.html',
	styleUrls: ['./employee-precenceupdate.component.scss']
})
export class EmployeePrecenceupdateComponent implements OnInit {

	@Input() employee: Employee;

	start: Date;
	stop: Date;
	presenceupdate: PresenceUpdate;

	edited: boolean = false;
	loading: boolean;
	direction: 'prev' | 'next' = undefined;

	constructor(
		private employeeService: EmployeeService,
		private messageService: MessageService,
		private dialogService: DialogService,
		private translateService: TranslateService,
		private modalService: NgbModal
	) {
		this.start = new Date();
		this.start.setDate(this.start.getDate() + (1 + 7 - this.start.getDay()) % 7 - 7);
		this.stop = new Date();
		this.stop.setDate(this.start.getDate() + 7);



	}

	ngOnInit(): void {

		if (this.employee) {
			this.loadEmployeeMatrix();
		}

	}

	prev(content: any): void {
		this.direction = 'prev';
		if (this.edited) {
			this.askSave(content);

		} else {
			this.start.setDate(this.start.getDate() - 7);
			this.stop.setDate(this.stop.getDate() - 7);

			this.loadEmployeeMatrix();
		}

	}

	askSave(content: any): void {
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });

	}

	move() {
		this.modalService.dismissAll();
		switch (this.direction) {
			case 'prev':
				this.prev(null);
				break;
			case 'next':
				this.next(null);
				break;
		}
	}

	moveWithoutSave(): void {
		this.edited = false;
		this.move();
	}

	next(content: any): void {
		this.direction = 'next';
		if (this.edited && content) {
			this.askSave(content);
		} else {
			this.start.setDate(this.start.getDate() + 7);
			this.stop.setDate(this.stop.getDate() + 7);

			this.loadEmployeeMatrix();
		}
	}


	loadEmployeeMatrix(): void {
		this.loading = true;
		this.employeeService.getEmployeeHourmatrix(this.employee.id, this.START, this.STOP).subscribe((data: PresenceUpdate) => {
			this.presenceupdate = data;
			this.loading = false;
			this.edited = false;
			this.direction = undefined;

		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}

	get START(): number {
		return Math.floor(this.start.getTime() / 1000);
	}

	get STOP(): number {
		return Math.floor(this.stop.getTime() / 1000);
	}

	save(): void {
		this.employeeService.saveEmployeeHourmatrix(this.employee.id, this.presenceupdate).subscribe((data: PresenceUpdate) => {

			if (this.direction) {
				this.edited = false;
				this.move();
			} else {
				this.loadEmployeeMatrix();
			}
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});


	}

	changed(d: PresenceUpdateDay) {
		console.log('changed', d);
		if (!d.value || d.value < 0) {
			d.value = 0;
		}
	}

	cancel(): void {
		this.loadEmployeeMatrix();
	}

	dismiss(): void {
		this.modalService.dismissAll();
	}




}
